import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

export function TableCell({ className, highlight, truncate, alignRight, numerical, ...props }) {
  return (
    <td
      className={classNames(
        styles.table_cell,
        highlight && styles.table_cell__highlight,
        truncate && styles.table_cell__truncate,
        alignRight && styles.table_cell__align_right,
        numerical && styles.table_cell__numerical,
        className,
      )}
      {...props}
    />
  );
}

TableCell.propTypes = {
  className: PropTypes.string,
  highlight: PropTypes.bool,
  truncate: PropTypes.bool,
  alignRight: PropTypes.bool,
  numerical: PropTypes.bool,
};
